<template>
  <section id="admin-model-list">

    <b-card class="admin-page-mobile">
      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-primary'"
        @click="showModal"
      >
        <feather-icon
          icon="PlusIcon"
          size="22"
          class="align-text-top"
        /> افزودن
      </b-button>
      <v-data-table
        v-bind="{dark : isMobile }"
        :headers="headers"
        :items="desserts"
        :search="search"
        mobile-breakpoint="0"
        loading
        loading-text="Loading... Please wait"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="جستجو"
            class="mx-4"
            style=""
          />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            @click="onEditItem(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            style="margin-right: 7px"
            @click="onDeleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
            variant="gradient-primary"
            @click="initialize"
          >
            بروزرسانی
          </v-btn>
        </template>
      </v-data-table>

      <!-- modal login-->
      <b-modal
        ref="modal-add"
        cancel-variant="outline-secondary"
        ok-title="افزودن"
        cancel-title="بستن"
        centered
        title="مشخصات"
      >
        <b-form>
          <!-- title -->
          <b-form-group
            label="عنوان"
            label-for="vi-title"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-title"
                v-model="plan.title"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>

          <!-- پروتکل -->
          <b-form-group
            label="توضیحات"
            label-for="vi-description"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-description"
                v-model="plan.description"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>

          <!-- port -->
          <b-form-group
            label="مدت اعتبار (ماه)"
            label-for="vi-period"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="CalendarIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-period"
                v-model="plan.period"
                type="number"
              />
            </b-input-group>
          </b-form-group>

          <!-- price -->
          <b-form-group
            label="قیمت (تومان)"
            label-for="vi-price"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="DollarSignIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-price"
                v-model="plan.priceToman"
                type="number"
                placeholder="مثال: 100000"
              />
            </b-input-group>
            <small class="text-muted">قیمت را به تومان وارد کنید</small>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="hideModal"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalOk()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>
    </b-card>

  </section>
</template>
<script>
import {
  BCard, BCardBody, BModal, BButton, BInputGroup, BInputGroupPrepend, BFormGroup, BFormInput, BCol, BForm,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Vue from 'vue'
import router from '@/router'

import PlanService from '@/services/plan.service'
import Plan from '@/models/plan'

import BreadcrumbMobile from '@/layouts/breadcrumb.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    BModal,
    BInputGroup,
    BInputGroupPrepend,
    BFormGroup,
    BFormInput,
    BCol,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      search: '',
      desserts: [],
      plan: {
        _id: '',
        title: '',
        description: '',
        period: '',
        price: 0,
        priceToman: '',
        disabled: false,
      },
      required,
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'عنوان',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: 'توضیحات', value: 'description' },
        { text: 'دوره (ماه)', value: 'period' },
        { text: 'قیمت (تومان)', value: 'priceFormatted' },
        { text: 'تاریخ ایجاد', value: 'creationDate' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async created() {
    this.$vuetify.rtl = true
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    initialize() {
      this.desserts = []
      PlanService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res) {
              for (let i = 0; i <= res.result.length - 1; i++) {
                const temp = res.result[i]
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                // فرمت قیمت - تبدیل ریال به تومان
                const priceToman = temp.price ? temp.price / 10 : 0
                temp.priceFormatted = new Intl.NumberFormat('fa-IR').format(priceToman)
                this.desserts.push(temp)
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ name: 'plan-add' })
    },
    modalOk() {
      this.locale = 'fa'
      // eslint-disable-next-line radix
      this.plan.period = parseInt(this.plan.period)
      // تبدیل قیمت تومان به ریال
      this.plan.price = parseInt(this.plan.priceToman || 0) * 10
      this.plan.disabled = false
      PlanService.add(this.plan).then(
        res => {
          if (res.status === 'success') {
            this.initialize()
            this.hideModal()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        PlanService.delete({
          // eslint-disable-next-line no-underscore-dangle
          _id: this.desserts[index]._id,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },
    onEditItem(item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      this.plan._id = this.desserts[index]._id.toString()
      this.plan.title = this.desserts[index].title.toString()
      this.plan.description = this.desserts[index].description ? this.desserts[index].description.toString() : ''
      this.plan.period = parseInt(this.desserts[index].period)
      // تبدیل ریال به تومان برای نمایش
      this.plan.price = this.desserts[index].price || 0
      this.plan.priceToman = this.plan.price > 0 ? (this.plan.price / 10).toString() : ''
      this.plan.disabled = false

      this.$refs['modal-add'].show()
    },
    showModal() {
      this.plan = {
        _id: '',
        title: '',
        description: '',
        period: '',
        price: 0,
        priceToman: '',
        disabled: false,
      }
      this.$refs['modal-add'].show()
    },
    hideModal() {
      this.$refs['modal-add'].hide()
    },
  },
}
</script>
